import { defineStore } from 'pinia';
import { io } from 'socket.io-client';
import { ETriggerId } from '~/types/toasts';
import { useStoreToasts } from '../strapi/toasts';
import type { Socket } from 'socket.io-client';

export const useStorePaymentsNotification = defineStore('paymentsNotification', {
  state: () => ({
    socket: null as Socket | null,
    wasSocketConnected: false,
  }),
  actions: {
    subscribe(userID: number) {
      if ((this.socket && !this.socket.disconnected) || (this.socket && this.wasSocketConnected)) {
        return;
      }

      this.wasSocketConnected = true;

      let host = window.location.host.replace(/^stage\.|^dev\.|^\d+-dev\./i, '');
      let subDomain = '';

      const originalHost = window.location.host;

      if (originalHost.includes('local')) {
        host = '7bitcasino.com';
        subDomain = 'dev-socket';
      } else if (originalHost.includes('dev')) {
        subDomain = 'dev-socket';
      } else if (originalHost.includes('stage')) {
        subDomain = 'stage-socket';
      } else {
        // case of production
        subDomain = 'socket';
      }

      this.socket = io(`https://${subDomain}.${host}/payments-push`, {
        transports: ['websocket'],
        secure: true,
      });

      this.socket.on('connect', () => {
        this.socket?.emit('subscribe', { userID: `_7bit_com_${userID}` });
      });

      this.socket.on('payment', this.onMessage);
    },
    unsubscribe() {
      this.socket?.emit('unsubscribe');
      this.socket?.off('payment', this.onMessage);
      this.wasSocketConnected = false;
    },
    onMessage(data: { error: string; email?: string }, ignoreGTM: boolean = false) {
      const error = data?.error;

      if (error) {
        // @ts-ignore
        useStoreToasts().add(ETriggerId[error], { isGTM: ignoreGTM });
      }
    },
  },
});
